import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BroadcastService } from '../../core/services/broadcast.service';
import { MyCampApp } from '../common/enumerations';
import { ReportApiService } from './report-api.service';
import { ServiceManagerBase } from '../common/service-manager-base';
import UserActionType = MyCampApp.UserActionType;
import { UserLoginReportData } from './user-login-report-data';
import { RegisteredUsersReportData } from './registered-users-report-data';
import { ActionReportData } from './action-report-data';
import { NotificationReportData } from './notification-report-data';
import { PhotoUploadReportData } from './photo-upload-report-data';
import { CheckInCheckOutReportData } from './check-in-check-out-report-data';
import { GlobalAdminReportData } from './global-admin-report-data';

@Injectable({
    providedIn: 'root'
})
export class ReportManagerService extends ServiceManagerBase
{
    constructor(private reportApiService: ReportApiService,
                protected override broadcastService: BroadcastService)
    {
        super(broadcastService);
    }

    protected clearCache()
    {
    }

    getUserLoginReport(startDate: Date, endDate: Date): Observable<UserLoginReportData>
    {
        return this.reportApiService.getUserLoginReport(startDate, endDate);
    }

    getRegisteredUserReport(startDate: Date, endDate: Date): Observable<RegisteredUsersReportData>
    {
        return this.reportApiService.getRegisteredUserReport(startDate, endDate);
    }

    getUserActionReport(startDate: Date, endDate: Date, actionType: UserActionType, additionalDataId: number): Observable<ActionReportData>
    {
        return this.reportApiService.getUserActionReport(startDate, endDate, actionType, additionalDataId);
    }

    getNotificationReport(startDate: Date, endDate: Date): Observable<NotificationReportData>
    {
        return this.reportApiService.getNotificationReport(startDate, endDate);
    }

    getPhotosReport(startDate: Date, endDate: Date): Observable<PhotoUploadReportData>
    {
        return this.reportApiService.getPhotosReport(startDate, endDate);
    }

    getUserLoginCsv(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getUserLoginCsv(startDate, endDate);
    }

    getRegisteredUsersCsv(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getRegisteredUserCsv(startDate, endDate);
    }

    getClientListCsv(): Observable<any>
    {
        return this.reportApiService.getClientListCsv();
    }

    getCheckInCheckOutCsv(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getCheckInCheckOutCsv(startDate, endDate);
    }

    getCheckInCheckOutReport(startDate: Date, endDate: Date): Observable<CheckInCheckOutReportData>
    {
        return this.reportApiService.getCheckInCheckOutReport(startDate, endDate);
    }

    getEventListCsv(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getEventListCsv(startDate, endDate);
    }

    getMultiOrgChildrenListCsv(): Observable<any>
    {
        return this.reportApiService.getMultiOrgChildrenListCsv();
    }

    getMultiOrgActivityListCsv(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getMultiOrgActivityListCsv(startDate, endDate);
    }

    getMultiOrgRegistrationListCsv(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getMultiOrgRegistrationListCsv(startDate, endDate);
    }

    emailPINReport(): Observable<any>
    {
        return this.reportApiService.emailPINReport();
    }

    getFaceRecognitionByChildReport(startDate: Date, endDate: Date): Observable<any>
    {
        return this.reportApiService.getFaceRecognitionByChildReport(startDate, endDate);
    }

	getGlobalAdminReport(startDate: Date, endDate: Date): Observable<GlobalAdminReportData>
	{
		return this.reportApiService.getGlobalAdminReport(startDate, endDate);
	}
}
